<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.71,7.29C13.71,7.29,10.71,4.29,10.71,4.29C10.53,4.11,10.28,4,10,4C9.45,4,9,4.45,9,5C9,5,9,11,9,11C9,11.55,9.45,12,10,12C10.28,12,10.53,11.89,10.71,11.71C10.71,11.71,13.71,8.71,13.71,8.71C13.89,8.530000000000001,14,8.280000000000001,14,8C14,7.720000000000001,13.89,7.470000000000001,13.71,7.29C13.71,7.29,13.71,7.29,13.71,7.29ZM6,4C5.720000000000001,4,5.470000000000001,4.11,5.29,4.29C5.29,4.29,2.29,7.29,2.29,7.29C2.11,7.470000000000001,2,7.720000000000001,2,8C2,8.280000000000001,2.11,8.530000000000001,2.29,8.71C2.29,8.71,5.29,11.71,5.29,11.71C5.470000000000001,11.89,5.720000000000001,12,6,12C6.55,12,7,11.55,7,11C7,11,7,5,7,5C7,4.45,6.55,4,6,4C6,4,6,4,6,4Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DoubleCaretHorizontal',
} as DefineComponent
</script>
